import { render, staticRenderFns } from "./financeiro-relatorio-perfil.vue?vue&type=template&id=33692e96&scoped=true"
import script from "./financeiro-relatorio-perfil.vue?vue&type=script&lang=ts"
export * from "./financeiro-relatorio-perfil.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-relatorio-perfil.vue?vue&type=style&index=0&id=33692e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33692e96",
  null
  
)

export default component.exports